import { ApiResponse } from '@marketplace-web/core-api/api-client-util'

import { api } from 'data/api/api'

import {
  GetConversationPhishingPassiveReminderResp,
  UpdateConversationPhishingPassiveReminderArgs,
} from '../types/phishing-passive-reminder'

export const getConversationPhishingPassiveReminder = (id: string) =>
  api.get<GetConversationPhishingPassiveReminderResp>(`msg_threads/${id}/safety_passive_reminder`)

export const updateConversationPhishingPassiveReminder = (
  id: string,
  args: UpdateConversationPhishingPassiveReminderArgs,
) => api.post<ApiResponse>(`msg_threads/${id}/safety_passive_reminder`, args)
